import React from 'react'

import { IconClose } from '../../icons/close'
import { IconButton } from '../../button'
import { Modal, ModalAriaProps } from '../../modal'
import styles from './youtube-embed-popup.module.scss'
import { useIntl } from 'react-intl'

interface VideoPopupProps {
  isOpen: boolean
  url: string
  title: string
  hidePopup: () => void
  autoplay?: boolean
  aria?: Partial<ModalAriaProps>
  dropShadow?: boolean
}

export const VideoPopup: React.FC<VideoPopupProps> = ({ hidePopup, url, isOpen, autoplay, title }) => {
  const youtubeParams = `?rel=0&autoplay=${autoplay ? '1' : '0'}&autohide=1&enablejsapi=1&showinfo=0&wmode=opaque`
  const fullYoutubeUrl = `${url}${youtubeParams}`
  const intl = useIntl()

  return (
    <Modal isOpen={isOpen} label={title} onRequestClose={hidePopup}>
      <div className={styles.content}>
        <div className={styles.closeButtonRowStyle}>
          <IconButton
            onClick={hidePopup}
            aria-label={intl.formatMessage({
              id: 'global.uiAction.close',
              description: 'Text for CTA that closes an element',
              defaultMessage: 'Close',
            })}
          >
            <IconClose color="neutral0" />
          </IconButton>
        </div>
        <iframe src={fullYoutubeUrl} allowFullScreen={false} allow={autoplay ? 'autoplay' : undefined} title={title} />
      </div>
    </Modal>
  )
}
